import { useContext, useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useFilters } from '@/hooks/useFilters';
import { SitesList } from '@/components/sites/sitesList';
import { SiteFilters } from '@/types/sites/filters';
import { SitesFilters } from '@/components/sites/sitesFilters';
import { useTranslation } from 'react-i18next';
import { AddSite } from '@/components/sites/addSite';
import { SitesContext } from '@/context/sitesContext';
import { usePermission } from '@/hooks/usePermission';

export const Route = createFileRoute('/_app/sites/')({
  component: RouteComponent,
});

const DEFAULT_FILTERS: SiteFilters = {
  name: null as string | null,
  city: null as string | null,
};

function RouteComponent() {
  const { t } = useTranslation();

  const { setPage, setActiveFilters } = useContext(SitesContext);

  const resetPage = () => {
    void setPage(1);
  };
  const canAddSite = usePermission('site.canEdit', { allowAnySite: true });

  const filters = useFilters(DEFAULT_FILTERS, { onFiltersChanged: resetPage });

  useEffect(() => {
    setActiveFilters(filters.serializedFilters);
  }, [ filters.serializedFilters ]);

  return (
    <div className="flex flex-col flex-1">
      <div className="flex justify-between items-center mb-space-2xl">
        <h1 className="text-3xl font-semibold">{ t('title', { ns: 'sites' }) }</h1>
        { canAddSite && <AddSite /> }
      </div>
      <div className="flex flex-col gap-6">
        <SitesFilters filters={ filters } />
        <SitesList />
      </div>
    </div>
  );
}
